import React, {useContext} from "react";
import {OptionContext} from "../../context/option-context";
import {AudioContext} from "../../context/audio-context";
import {VideoContext} from "../../context/video-context";
import classes from "./options.module.css"
import {MouseHover} from "./MouseHover";
import {getParagraphCssClass} from "./Paragraph";

export const Button = ({children, onClick, className, type}) => {
    const optionsContext = useContext(OptionContext);
    const audioContext = useContext(AudioContext);
    const videoContext = useContext(VideoContext);

    const onClickHandle = (text) => {
        if (optionsContext.sound) {
            audioContext.onChangeAudio(text)
        }
        if (optionsContext.signMark) {
            videoContext.onChangeVideo(text)
        }
        if (onClick) {
            onClick();
        }
    }

    const buttonClasses = [];

    buttonClasses.push(getParagraphCssClass(optionsContext.fontSize, className))

    if (optionsContext.highlightText) {
        buttonClasses.push(classes.Highlight)
    }

    return (
        <button type={type} className={className} onClick={() => onClickHandle(children)}>
            <MouseHover className={buttonClasses.join(" ")}>{children.toString()}</MouseHover>
        </button>
    )
}